<template>
  <div>
    <h3>{{ $t('message.script_config_syslog_server') | title }}</h3>

    <div v-if="willRunOnEachClusterNode" class="cluster-info">
      {{ $t('message.will_run_on_each_cluster_node') | title }}
    </div>
    <div v-if="willRunOnThisClusterNodeOnly" class="cluster-info">
      {{ $t('message.will_run_on_this_cluster_node_only') | title }}
    </div>

    <b-form>
      <b-card v-for="(destination, destIndex) in destinations" :key="destIndex" class="destination-details">
        <b-form-row>
          <div class="col-3">
            <span class="label label-default">
              {{ $t("message.syslog_server_destination_remote_host") | title }}
            </span>
          </div>
          <div class="col-8">
            <b-form-input type="url" v-model="destination.remote_host"/>
          </div>
        </b-form-row>

        <b-form-row>
          <div class="col-3">
            <span class="label label-default">
              {{ $t("message.syslog_server_destination_transport") | title }}
            </span>
          </div>
          <div class="col-8">
            <b-form-select v-model="destination.transport" :options="['tcp', 'udp']"/>
          </div>
        </b-form-row>

        <b-form-row>
          <div class="col-3">
            <span class="label label-default">{{ $t("message.syslog_server_destination_port") | title }}</span>
          </div>
          <div class="col-8">
            <b-form-input type="number" v-model="destination.port"/>
          </div>
        </b-form-row>

        <b-form-row>
          <div class="col-3">
            <span class="label label-default">{{ $t("message.syslog_server_destination_send_system_log") | title }}</span>
          </div>
          <span class="col">
            <div class="col-4 form-group form-check">
              <input type="checkbox" class="form-check-input" v-model="destination.send_system_log"/>
            </div>
          </span>
        </b-form-row>

        <b-form-row>
          <div class="col-3">
            <span class="label label-default">{{ $t("message.syslog_server_destination_send_activity_log") | title }}</span>
          </div>
          <span class="col">
            <div class="col-4 form-group form-check">
              <input type="checkbox" class="form-check-input" v-model="destination.send_activity_log"/>
            </div>
          </span>
        </b-form-row>

        <div v-if="destination.error" class="form-error">{{ destination.error }}</div>

        <b-button @click="delDestination(destIndex)" type="button" class="padmin-button del-button">
          {{$t('message.button_delete') | title}}
        </b-button>
      </b-card>

      <div>
        <b-button class="padmin-button" @click="addDestination" variant="primary">
          {{ $t("message.button_new") | title }}
        </b-button>
        <b-button class="padmin-button submit-button" variant="primary" @click="save" :disabled="runInProgress">
          <b-spinner v-if="runInProgress" small type="grow"/>
          {{$t('message.button_save') | title}}
        </b-button>
      </div>
    </b-form>

    <ConsoleOutput v-if="result != null" :result="result" :output="output"/>
  </div>
</template>

<script>
import { get, post } from '../http';
import ConsoleOutput from './ConsoleOutput';

export default {
  name: 'SyslogServer',

  components: {
    ConsoleOutput
  },

  props: {},

  data() {
    return {
      destinations: [],
      result: null,
      output: '',
      runInProgress: false
    };
  },

  mounted () {
    this.load()
  },

  methods: {
    getUrl () {
      return ('/scripts/config/syslog_server')
    },

    load () {
      get(this.getUrl()).then(
        resp => {
          this.willRunOnEachClusterNode = resp.data.will_run_on_each_cluster_node
          this.willRunOnThisClusterNodeOnly = resp.data.will_run_on_this_cluster_node_only
          this.destinations = resp.data.params.syslog_server_config.value.destinations
          if (!this.destinations) {
            this.destinations = []
          }
        },
        err => {
          console.log('err', err)
        }
      );
    },

    save () {
      this.destinations.forEach(dest => {
        delete dest.error
      })

      if (!this.validate()) {
        return
      }

      let data = {destinations: this.destinations}

      this.result = null
      this.output = ''
      this.runInProgress = true

      post(this.getUrl(), data, { 'Content-Type': 'application/json' }).then(
        resp => {
          this.result = resp.data.result
          this.output = resp.data.output
          this.runInProgress = false
        },
        err => {
          this.runInProgress = false
          this.result = false
          console.log('err', err)
        }
      );
    },

    validate() {
      let destNames = []
      for (let iDest = 0; iDest < this.destinations.length; iDest++) {
        let dest = this.destinations[iDest]
        if (dest.port < 1 || dest.port > 65535) {
          this.$set(dest, 'error',
            this.$t('message.syslog_server_destination_error_invalid_port'))
          return false
        }
      }

      return true
    },

    addDestination () {
      this.destinations.push({
        remote_host: '',
        transport: 'tcp',
        port: 514,
        send_system_log: true,
        send_activity_log: false
      })
    },

    delDestination (destIndex) {
      this.destinations.splice(destIndex, 1)
    }
  }
};
</script>
<style scoped>
@import "./../styles/syslogServerComponent.css";
</style>
